import cn from 'classnames';
import { EngineTheme } from '@websky/core/src/theme';

import BaseComponents from './components/BaseComponents/BaseComponents.css';
import Buttons from './components/BaseComponents/Buttons.css';
import Stepbar from './components/Stepbar/Stepbar.css';
import PromoLoader from './components/PromoLoader/PromoLoader.css';
import Checkin from './components/Checkin/Checkin.css';
import Notification from './components/Notification/Notification.css';
import BoardingPassMob from './components/BoardingPassMob/BoardingPassMob.css';
import BoardingPassDesk from './components/BoardingPassDesk/BoardingPassDesk.css';
import Money from './components/Money/Money.css';

import RefundPassengers from './components/Refund/Passengers/Passengers.css';
import RefundPassenger from './components/Refund/Passenger/Passenger.css';
import RefundStepTitle from './components/Refund/StepTitle/StepTitle.css';
import RefundBreadcrumbs from './components/Refund/Breadcrumbs/Breadcrumbs.css';
import RefundStepsButtons from './components/Refund/StepsButtons/StepsButtons.css';
import RefundWrapper from './components/Refund/Wrapper/Wrapper.css';
import RefundMobileStep from './components/Refund/MobileStep/MobileStep.css';
import RefundReasonForm from './components/Refund/ReasonForm/ReasonForm.css';
import RefundReason from './components/Refund/Reason/Reason.css';
import RefundRequestForm from './components/Refund/RequestForm/RequestForm.css';
import Refund from './components/Refund/Refund/Refund.css';

import ExchangeCommonSelect from './components/Exchange/CommonSelect/CommonSelect.css';
import ExchangeChoice from './components/Exchange/Choice/Choice.css';
import ExchangeInner from './components/Exchange/Inner/Inner.css';
import ExchangeChip from './components/Exchange/Chip/Chip.css';
import ExchangeSearchFlights from './components/Exchange/SearchFlights/SearchFlights.css';
import ExchangeSelections from './components/Exchange/Selections/Selections.css';
import ExchangeCreateRequest from './components/Exchange/CreateRequest/CreateRequest.css';
import ExchangeRequestControls from './components/Exchange/RequestForm/RequestControls/RequestControls.css';

import FullscreenDialog from './components/FullscreenDialog/FullscreenDialog.css';
import AdditionalBanner from './components/AdditionalServiceBanner/AdditionalBanner.css';
import BaggagePage from './components/BaggagePage/BaggagePage.css';
import BaggageList from './components/BaggageList/BaggageList.css';
import Counter from './components/Counter/Counter.css';
import IncludedBaggage from './components/IncludedBaggage/IncludedBaggage.css';
import PromoMessage from './components/AdditionalBaggage/PromoMessage/PromoMessage.css';
import BaggageTotalPriceBlock from './components/BaggageTotalPriceBlock/BaggageTotalPriceBlock.css';
import BaggageFooter from './components/UpgradeBaggageDialog/BaggageFooter/BaggageFooter.css';
import BaggageCard from './components/BaggageCard/BaggageCard.css';
import HeaderEquipmentItem from './components/UpgradeBaggageDialog/HeaderEquipmentItem/HeaderEquipmentItem.css';
import BaggageDialogHeader from './components/UpgradeBaggageDialog/BaggageDialogHeader/BaggageDialogHeader.css';
import MobileBaggageSelector from './components/UpgradeBaggageDialog/MobileBaggageSelector/MobileBaggageSelector.css';
import BaggageIcon from './components/Baggage/BaggageIcon/BaggageIcon.css';
import OverweightBaggage from './components/OverweightBaggage/OverweightBaggage.css';
import SpecialEquipment from './components/SpecialEquipment/SpecialEquipment.css';
import Baggage from './components/Baggage/Baggage/Baggage.css';
import MealService from './components/MealService/MealService.css';
import ServiceWithSegments from './components/ServiceWithSegments/ServiceWithSegments.css';
import Passengers from './components/Passengers/Passengers.css';
import Checkout from './components/Checkout/Checkout.css';
import Amenities from './components/Amenities/Amenities.css';
import SeatMap from './components/SeatMap/SeatMap.css';
import Seat from './components/SeatMap/Seat/Seat.css';
import SeatsInfo from './components/SeatMap/SeatsInfo/SeatsInfo.css';
import SeatMapPassenger from './components/SeatMap/Passengers/Passenger/Passenger.css';
import SearchForm from './components/SearchForm/SearchForm.css';
import Results from './components/Results/Results.css';
import ResultsSortings from './components/Results/Sortings/Sortings.css';
import DesktopFlightRoute from './components/DesktopFlightRoute/DesktopFlightRoute.css';
import DesktopFlight from './components/DesktopFlight/DesktopFlight.css';
import FlightCard from './components/FlightCard/FlightCard.css';
import CompareFares from './components/CompareFares/CompareFares.css';
import MobileFlight from './components/MobileFlight/MobileFlight.css';
import SearchFormDatepicker from './components/SearchFormDatepicker/SearchFormDatepicker.css';
import PaymentForm from './components/PaymentForm/PaymentForm.css';
import CheckoutAdditionalService from './components/CheckoutAdditionalService/CheckoutAdditionalService.css';
import RetrieveBooking from './components/RetrieveBooking/RetrieveBooking.css';
import PassengersContent from './components/PassengersContent/PassengersContent.css';

const theme: EngineTheme = {
	Checkin: {
		PassengersHeader: {
			container: Checkin.passengersHeader__container,
			title: Checkin.passengersHeader__title
		},
		ConditionsModal: {
			button: Checkin.conditionsModal__button,
			icon: Checkin.conditionsModal__icon
		},
		Passengers: {
			timelimit: Checkin.passengers__timelimit
		},
		PassengersContent: {
			passenger: PassengersContent.passenger,
			selectedPassenger__deleteButton: PassengersContent.selectedPassenger__deleteButton
		},
		Order: {
			container: Checkin.order__container
		},
		Inital: {
			wrapper: Checkin.inital__wrapper,
			content: Checkin.inital__content
		},
		Conditions: {
			title: Checkin.conditions__title,
			conditions: Checkin.conditions__conditions
		}
	},
	ResendTicketsForm: {
		ResendTicketsForm: {
			footer: Checkin.resendTicketsForm__footer
		}
	},
	RegisteredPassenger: {
		Header: {
			passenger__name: Checkin.registeredPassenger__name,
			seats__text: Checkin.registeredPassenger__seats__text
		},
		Controls: {
			container: Checkin.controls__container,
			controlImg: Checkin.controls__controlImg
		}
	},
	StatusMessage: {
		StatusMessage: {
			statusMessage__title: Checkin.statusMessage__title,
			statusMessage__text: Checkin.statusMessage__text
		}
	},
	Segment: {
		BoardingPassDesk: {
			flightInfo: BoardingPassDesk.flightInfo,
			flightInfo__title: BoardingPassDesk.flightInfo__title,
			flightInfo__departure: BoardingPassDesk.flightInfo__departure,
			flightInfo__value: BoardingPassDesk.flightInfo__value,
			city__iata: BoardingPassDesk.city__iata,
			city__airport: BoardingPassDesk.city__airport,
			city__time: BoardingPassDesk.city__time,
			footer__itemLabel: BoardingPassDesk.footer__itemLabel,
			footer__itemValue: BoardingPassDesk.footer__itemValue,
			airline__name: BoardingPassDesk.airline__name
		}
	},
	MobileSegment: {
		MobileSegment: {
			header: BoardingPassMob.header,
			info__iata: BoardingPassMob.info__iata,
			info__cities: BoardingPassMob.info__cities,
			info__time: BoardingPassMob.info__time,
			arrivalInfo__itemLabel: BoardingPassMob.arrivalInfo__itemLabel,
			arrivalInfo__itemValue: BoardingPassMob.arrivalInfo__itemValue
		}
	},
	SelectedPassenger: {
		SelectedPassenger: {
			passengerName: Checkin.passengerName,
			passengerInfo__item: Checkin.passengerInfo__item,
			icon: Checkin.selectedPassenger__icon
		}
	},
	Notification: {
		Notification: {
			wrapper: Notification.wrapper,
			wrapper__inner: Notification.wrapper__inner,
			icon: Notification.icon,
			title: Notification.title,
			text: Notification.text,
			context: Notification.context
		}
	},
	DesktopFlightInfo: {
		DesktopFlightInfo: {},
		Point: {
			point: Checkout.point__point,
			terminal: Checkout.point__terminal
		},
		Segment: {
			duration: Checkout.segment__duration,
			airline: Checkout.segment__airline
		}
	},
	Amenities: {
		Amenities: {
			amenities: Passengers.amenities,
			amenities__item: cn(Amenities.amenities__item, Passengers.amenities__item, Checkout.amenities__item)
		}
	},
	CardExtra: {
		CardExtraContent: {
			header__title: Checkout.cardExtra__header__title,
			description: Checkout.cardExtra__description
		}
	},
	OrderCard: {
		CommonItem: { root: Checkout.commonItem__root, icon: Checkout.commonItem__icon },
		PaymentStatus: {
			root: Checkout.paymentStatus__root,
			icon: Checkout.paymentStatus__icon
		},
		OrderStatus: {
			root: Checkout.orderStatus__root,
			icon: Checkout.orderStatus__icon,
			type_review: Checkout.orderStatus__type_review,
			confirmed: Checkout.orderStatus__confirmed
		},
		OrderCard: {
			root: Checkout.orderCard__root,
			container: Checkout.orderCard__container,
			type_review: Checkout.orderCard__type_review
		},
		OrderBooking: {
			root: Checkout.orderBooking__root,
			type_review: Checkout.orderBooking__type_review,
			orderCode: Checkout.orderBooking__orderCode,
			security_code: Checkout.orderBooking__securityCode
		},
		OrderPassengers: {
			control: Checkout.orderPassengers__control
		}
	},
	ServiceWithSegments: {
		ServiceWithSegments: {
			service: cn(Checkout.serviceWithSegments__service, ServiceWithSegments.service),
			title: ServiceWithSegments.title
		}
	},
	DesktopSummaryFlight: {
		Header: {
			header: Passengers.summaryFlight__header,
			title: Passengers.summaryFlight__title,
			travelTime: Passengers.summaryFlight__travelTime,
			header__cell: Passengers.summaryFlight__header__cell,
			fareGroup__name: Passengers.summaryFlight__fareGroup__name,
			price: Passengers.summaryFlight__price,
			arrowIcon: Passengers.summaryFlight__arrowIcon,
			fareGroup__logo: Passengers.summaryFlight__fareGroup__logo
		}
	},
	Results: {
		Results: {
			results: Results.results,
			header__stepbar: Results.header__stepbar
		},
		Calendar: {
			legNumber: Results.calendar__legNumber,
			title__cities: Results.calendar__title__cities,
			diagram: Results.calendar__diagram
		},
		Sortings: {
			title: ResultsSortings.title,
			sortBy: ResultsSortings.sortBy,
			currentSorting: ResultsSortings.currentSorting,
			sortings: ResultsSortings.sortings,
			flightType: ResultsSortings.flightType,
			flightType__active: ResultsSortings.flightType__active,
			listItem: ResultsSortings.listItem,
			listItem_active: ResultsSortings.listItem_active,
			paper: ResultsSortings.paper,
			mobile: ResultsSortings.mobile,
			mobile__list: ResultsSortings.mobile__list,
			mobile__list__title: ResultsSortings.mobile__list__title,
			mobile__list__close: ResultsSortings.mobile__list__close,
			mobile__list__item: ResultsSortings.mobile__list__item,
			mobile__list__button: cn(ResultsSortings.mobile__list__button),
			mobile__list__button_inactive: ResultsSortings.mobile__list__button_inactive,
			mobile__closeButton: ResultsSortings.mobile__closeButton,
			slideBottom: ResultsSortings.slideBottom,
			switchWrp: ResultsSortings.switchWrp
		},
		FlightsList: {
			leg: Results.flightList__leg,
			controls__wrapper: Results.flightList__controls__wrapper
		}
	},
	SearchFormDatepicker: {
		SearchFormDatepickerStyles: {
			popup: SearchFormDatepicker.popup
		},
		MonthStyles: {
			week: SearchFormDatepicker.monthStyles_week
		},
		DayStyles: {
			day_withPrice: SearchFormDatepicker.day_withPrice,
			day_selected: SearchFormDatepicker.day_selected,
			day_endHover_withPrice: SearchFormDatepicker.day_endHover_withPrice,
			day_startHover_withprice: SearchFormDatepicker.day_startHover_withprice
		}
	},

	DesktopFlight: {
		SelectedFareGroup: {
			rules: DesktopFlight.selectedFareGroup__rules,
			button__rules: DesktopFlight.selectedFareGroup__button__rules
		},
		DesktopFlightModalHeader: {
			title: DesktopFlight.modal__title
		},
		ModalContent: {
			fareGroup__button: DesktopFlight.fareGroup__button,
			fareGroup__button_active: DesktopFlight.fareGroup__button_active,
			content_wrapper: DesktopFlight.content_wrapper,
			compareFaresLink: DesktopFlight.compareFaresLink
		},
		Location: {
			time: DesktopFlight.location__time,
			date: DesktopFlight.location__date,
			city: DesktopFlight.location__city,
			terminal: DesktopFlight.location__terminal
		}
	},
	FlightCard: {
		FlightCard: {
			wrapper: FlightCard.wrapper,
			flight: FlightCard.flight,
			airline: FlightCard.airline,
			airline__number: FlightCard.airline__number,
			airline__name: FlightCard.airline__name,
			aircraft__nameTitle: FlightCard.aircraft__nameTitle
		}
	},
	FullscreenDialog: {
		FullscreenDialog: {
			close__text: BaseComponents.fullscreenmodal__close__text,
			close__icon: cn(BaseComponents.fullscreenmodal__closeIcon, FullscreenDialog.close__icon)
		}
	},
	DesktopFlightRoute: {
		DesktopFlightRouteStyles: {
			flight: DesktopFlightRoute.flight,
			selected: DesktopFlightRoute.selected
		},
		SegmentStyles: {
			planeInfo: DesktopFlightRoute.segment__planeInfo,
			flightInfo: DesktopFlightRoute.segment__flightInfo,
			flightInfo__date: DesktopFlightRoute.segment__date,
			flightInfo__airline: DesktopFlightRoute.airline,
			aircraft: DesktopFlightRoute.aircraft,
			flightInfo__icon: DesktopFlightRoute.flightInfo__icon
		},
		RouteArrowStyles: {
			timeInRoute: DesktopFlightRoute.timeInRoute,
			flightNumber: DesktopFlightRoute.flightNumber
		},
		PointStyles: {
			airport: DesktopFlightRoute.airport,
			time: DesktopFlightRoute.time,
			date: DesktopFlightRoute.date
		},
		StopsInfoStyles: {
			stop__label: DesktopFlightRoute.stop__label
		},
		FlightPriceStyles: {
			fare_family: DesktopFlightRoute.flightPrice__fare_family,
			price__money: DesktopFlightRoute.flightPrice__price__money,
			button: DesktopFlightRoute.flightPrice__button,
			best: DesktopFlightRoute.flightPrice__best
		},
		RouteInfoStyles: {
			row: DesktopFlightRoute.row,
			route__info: DesktopFlightRoute.route__info
		}
	},
	MobileFlight: {
		FlightStyles: {
			flight: MobileFlight.flight,
			price: MobileFlight.price,
			price__money: MobileFlight.price__money,
			selectedFare: MobileFlight.selectedFare,
			selectedFare__price: MobileFlight.selectedFare__price,
			price__wrapper: MobileFlight.price__wrapper,
			selectedFare__priceWrapper: MobileFlight.selectedFare__priceWrappe
		}
	},
	CompareFares: {
		Fare: {
			fareHeadingItem: CompareFares.fareHeadingItem,
			fareHeadingItem_isKey: CompareFares.fareHeadingItem_isKey,
			fareHeadingItem__title: CompareFares.fareHeadingItem__title
		}
	},
	FareGroup: {
		FareGroupIcon: {
			container: DesktopFlight.fareGroupIcon__container
		},
		FareGroup: {
			fareGroup: DesktopFlight.fareGroup,
			option__title: DesktopFlight.fareGroup__option__title,
			option_free: DesktopFlight.fareGroup__option_free,
			option__value: DesktopFlight.fareGroup__option__value,
			option: DesktopFlight.fareGroup__option,
			options: DesktopFlight.fareGroup__options
		},
		FareGroupGrid: {
			upgradeOffer: DesktopFlight.fareGroup__upgradeOffer,
			recommended: DesktopFlight.fareGroup__recommended,
			option: DesktopFlight.fareGroup__option,
			small: DesktopFlight.fareGroup__small,
			paid: DesktopFlight.fareGroup__paid,
			header: DesktopFlight.fareGroup__header
		},
		RecommendedBadge: {
			wrapper: DesktopFlight.fareGroup__recommended__wrapper,
			badge: DesktopFlight.fareGroup__recommended__badge
		}
	},
	SearchForm: {
		SearchForm: {
			searchForm: SearchForm.searchForm
		},
		StartSearch: {
			startSearch: SearchForm.startSearch,
			startSearch_multiCity: SearchForm.startSearch_multiCity
		},
		Location: {
			switcher: SearchForm.location__switcher,
			switcher_alternative: SearchForm.location__switcher_alternative
		},
		Value: {
			wrapper_alternative: SearchForm.value__wrapper_alternative,
			value: SearchForm.value__value,
			code: SearchForm.value__code
		},
		Datepicker: {
			date__inputWrapper: SearchForm.datepicker__date__inputWrapper,
			dow: SearchForm.datepicker__dow,
			dates__to_text: SearchForm.dates__to_text,
			dates: SearchForm.dates,
			dates__back: SearchForm.datepicker__dates__back,
			highlighted_minPrice: SearchForm.datepicker__highlighted_minPrice
		},
		Passengers: {
			alternative: SearchForm.passengers__alternative,
			selector: SearchForm.passengers__selector,
			title: SearchForm.passengers__title,
			passengers_isMultiCity: SearchForm.passengers_isMultiCity
		},
		MultiCity: {
			caption: SearchForm.multiCity__caption
		},
		SearchFormSwitch: {
			label: SearchForm.searchFormSwitch__label
		},
		Bottom: {
			controls: SearchForm.bottom__controls
		},
		Controls: {
			controls_multiCity: SearchForm.controls_multiCity
		},
		Segment: {
			segment: SearchForm.segment__segment,
			datepicker_value: SearchForm.segment__datepicker_value,
			withMultiCity: SearchForm.segment__withMultiCity,
			cell: SearchForm.segment__cell,
			input: SearchForm.segment__input
		},
		Actions: {
			addSegment: SearchForm.segment__addSegment,
			removeSegment: SearchForm.segment__removeSegment
		}
	},
	Datepicker: {
		MonthHeaderStyles: {
			monthHeader: SearchFormDatepicker.monthHeaderStyles_monthHeader
		},
		WeeklyHeaderStyles: {
			day: SearchFormDatepicker.weeklyHeader_weeklyDay
		},
		MonthStyles: {
			week: SearchFormDatepicker.monthStyles_week,
			monthWrapper: SearchFormDatepicker.monthWrapper
		}
	},
	PromoCode: {
		PromoCode: {
			promoCode: SearchForm.promoCode,
			trigger: SearchForm.promoCode__trigger,
			clearWrapper: SearchForm.promocode__clearWrapper
		},
		PromoCodeForm: {
			form: SearchForm.promocode_form,
			button: SearchForm.promocode_form__button
		}
	},
	QuickSearchForm: {
		QuickSearchForm: {
			form: SearchForm.quickSearchForm
		},
		Summary: {
			route: SearchForm.summary__route,
			dates: SearchForm.summary__dates,
			passengers: SearchForm.summary__passengers,
			editButtonWrapper: SearchForm.summary__editButtonWrapper
		}
	},
	Checkout: {
		CheckoutStyles: {
			checkout: Checkout.checkout,
			gdsTotalPrice: BaseComponents.toolbar__gdsTotalPrice,
			checkoutServices: Checkout.checkoutServices,
			selectedFlight__container: Checkout.checkout__selectedFlight__container
		},
		PassengersToolbar: {
			label: cn(BaseComponents.checkbox__label, Passengers.checkbox__label),
			checkbox: cn(Passengers.passengersToolbar__checkbox, Checkout.passengersToolbar__checkbox),
			checkbox_checked: Passengers.passengersToolbar__checkboxChecked
		},
		Stepbar: {
			paper: Checkout.stepbar__paper
		}
	},
	Contacts: {
		ContactsStyles: {
			form: Passengers.contacts__form,
			description__header: Passengers.contacts__description__header,
			description__text: Passengers.contacts__description__text,
			footer__text: Passengers.contacts__footer__text,
			footer_login: Passengers.contacts__footer_login,
			footer__inner: Passengers.footer__inner
		}
	},
	RetrieveBooking: {
		ClarifyDocumentModal: {
			submit: cn(Buttons.action, Buttons.autoHeight)
		},
		RetrieveBooking: {
			button: RetrieveBooking.button,
			container_checkin: RetrieveBooking.container_checkin
		}
	},
	PassengerForm: {
		Group: {
			identity: Passengers.group__identity,
			documents: Passengers.group__documents,
			accompanying: Passengers.group__accompanying
		},
		LoyaltyGroup: {
			loyalty__desc: Passengers.group__loyalty__desc,
			loyalty: Passengers.group__loyalty
		},
		Header: {
			header: Passengers.header_header,
			filled: Passengers.header_filled,
			number: Passengers.header_number
		}
	},
	Toolbar: {
		Toolbar: {
			price: BaseComponents.toolbar__price
		}
	},
	BaseComponents: {
		Button: {
			smallPrimary: Buttons.smallPrimary,
			smallSecondary: Buttons.smallSecondary,
			smallBrand: Buttons.smallBrand,
			smallNeitral: Buttons.smallNeitral,
			optionActionPlusIcon: Buttons.optionActionPlusIcon,
			action: Buttons.action,
			secondary: Buttons.secondary,
			optionEdit: Buttons.optionEdit,
			optionAction: Buttons.optionAction
		},
		IconButton: {
			root: Buttons.iconButton__root
		}
	},
	Button: {
		ActionButton: {
			button: Buttons.action
		}
	},
	Counter: {
		Counter: {
			counter: Counter.counter,
			value: Counter.value,
			button: Counter.button,
			button_disabled: Counter.button_disabled
		}
	},
	CloseIcon: {
		CloseIcon: {
			wrapper: BaseComponents.closeIcon_wrapper
		}
	},
	Modal: {
		Modal: {
			closeIcon: BaseComponents.modal__closeIcon,
			modal: BaseComponents.modal,
			modal_rounded: BaseComponents.modal_rounded,
			modal_bottom: BaseComponents.modal_bottom
		}
	},
	WarningModal: {
		WarningModal: {
			header: BaseComponents.warningModal_header,
			paper: BaseComponents.warningModal_paper,
			scrollBody: BaseComponents.warningModal_scrollBody
		}
	},
	Link: {
		Link: {
			link: BaseComponents.link
		}
	},
	Input: {
		Input: {
			input: BaseComponents.input,
			input_filled: BaseComponents.input_filled,
			real_input: BaseComponents.real_input,
			textField__root: BaseComponents.textField__root,
			textField_filled: BaseComponents.textField_filled,
			label_shrink: BaseComponents.label_shrink,
			textField_focused: BaseComponents.textField_focused,
			label_error: BaseComponents.textField_label_error,
			input_focused: BaseComponents.input_focused,
			hint: BaseComponents.hint,
			hint_error: BaseComponents.hint_error
		}
	},
	Passenger: {
		PassengerSwitch: {
			element: BaseComponents.switch__element,
			element_active: BaseComponents.switch__element_active,
			element_error: BaseComponents.switch__element_error
		},
		Select: {
			input: BaseComponents.input,
			input_standard: BaseComponents.input_standard,
			input_focused: BaseComponents.input_focused,
			helperText: BaseComponents.select_helperText
		}
	},
	Passengers: {
		PassengerStyles: {
			decrease: Passengers.counter_decrease,
			increase: Passengers.counter_increase
		}
	},
	MobileStepbar: {
		StepbarHeader: {
			header: Stepbar.mobileStepbar__header,
			expand: Stepbar.mobileStepbar__header__expand
		},
		StepbarServiceSummary: {
			content: Stepbar.serviceSummary__content,
			header__title: Stepbar.header__title,
			button_add: Stepbar.mobileStepbar__button_add
		},
		MobileStepbarStyles: {}
	},
	ServiceSummary: {
		ServiceSummaryOption: {
			wrapper: Checkout.serviceSummary__wrapper,
			option__iconIncluded: Checkout.serviceSummary__option__iconIncluded,
			header__title: Stepbar.serviceSummary__header__title,
			option: Stepbar.serviceSummary__option,
			option__name: Stepbar.serviceSummary__option__name,
			option__price: Stepbar.serviceSummary__option__price,
			option__icon: Stepbar.serviceSummary__option__icon
		},
		ServiceSummary: {
			content: Stepbar.serviceSummary__content
		}
	},
	PromoLoader: {
		PromoLoader: {
			wrapper: PromoLoader.wrapper,
			promo: PromoLoader.promo,
			promo__image: PromoLoader.promo__image,
			promo__icon: PromoLoader.promo__icon
		}
	},
	Refund: {
		Passengers: {
			passengers: RefundPassengers.passengers,
			passenger: RefundPassengers.passenger
		},
		Passenger: {
			passenger: RefundPassenger.passenger,
			checkbox: RefundPassenger.checkbox,
			active: RefundPassenger.active
		},
		StepTitle: {
			icon: RefundStepTitle.icon
		},
		Breadcrumbs: {
			breadcrumb: RefundBreadcrumbs.breadcrumb
		},
		StepsButtons: {
			button: RefundStepsButtons.button,
			backButton: RefundStepsButtons.backButton
		},
		Wrapper: {
			header_wrapper: RefundWrapper.header_wrapper,
			header: RefundWrapper.header,
			title: RefundWrapper.title
		},
		MobileStep: {
			header: RefundMobileStep.header
		},
		ReasonForm: {
			paper: RefundReasonForm.paper,
			groupWrapper: RefundReasonForm.groupWrapper,
			reasons: RefundReasonForm.reasons,
			reason: RefundReasonForm.reason,
			groupTitle: RefundReasonForm.groupTitle
		},
		Reason: {
			radio: RefundReason.radio,
			label: RefundReason.label,
			active: RefundReason.active
		},
		RequestForm: {
			agree: RefundRequestForm.agree
		},
		Refund: {
			prices: Refund.prices
		},
		RefundPaper: {
			paper: Refund.paper
		},
		OrderRefundStatus: {
			success: Refund.orderRefundStatus__success,
			right: Refund.orderRefundStatus__right
		}
	},
	Exchange: {
		CommonSelect: {
			header: ExchangeCommonSelect.header,
			icon: ExchangeCommonSelect.icon,
			button: ExchangeCommonSelect.button,
			back: ExchangeCommonSelect.back
		},
		Choice: {
			container: ExchangeChoice.container,
			label: ExchangeChoice.label,
			label_selected: ExchangeChoice.label_selected,
			button: ExchangeChoice.button,
			button_checked: ExchangeChoice.button_checked,
			labelDate: ExchangeChoice.labelDate,
			labelInner: ExchangeChoice.labelInner
		},
		Inner: {
			header: ExchangeInner.header,
			header__text: ExchangeInner.header__text,
			header__inner: ExchangeInner.header__inner
		},
		Chip: {
			chip: ExchangeChip.chip,
			close: ExchangeChip.close
		},
		SearchFlights: {
			header: ExchangeSearchFlights.header
		},
		Selections: {
			wrapper: ExchangeSelections.wrapper
		},
		CreateRequest: {
			label: ExchangeCreateRequest.label,
			submit: cn(ExchangeCreateRequest.submit, Buttons.action)
		},
		RequestControls: {
			button: ExchangeRequestControls.button,
			container: ExchangeRequestControls.container
		}
	},
	RefundSummary: {
		Notice: {
			reject: Refund.reject_notice
		}
	},
	AdditionalServiceBanner: {
		AdditionalServiceBannerStyles: {
			disclaimer: AdditionalBanner.disclaimer,
			disclaimer__icon: AdditionalBanner.disclaimer__icon
		}
	},
	BaggagePage: {
		BaggagePage: {
			newBaggage: BaggagePage.baggagePage__newBaggage
		}
	},
	BaggageList: {
		BaggageList: {
			footer: BaggageList.baggageList__footer,
			add: BaggageList.baggageList__add
		}
	},
	IncludedBaggage: {
		IncludedBaggage: {
			header: IncludedBaggage.includedBaggage__header
		}
	},
	AdditionalBaggage: {
		PromoMessage: {
			root: PromoMessage.root
		}
	},
	BaggageTotalPriceBlock: {
		BaggageTotalPriceBlock: {
			price: BaggageTotalPriceBlock.price
		}
	},
	UpgradeBaggageDialog: {
		BaggageFooter: {
			clear: BaggageFooter.clear
		},
		HeaderEquipmentItem: {
			wrapper: HeaderEquipmentItem.wrapper,
			active: HeaderEquipmentItem.active,
			selected: HeaderEquipmentItem.selected
		},
		BaggageDialogHeader: {
			category_title: BaggageDialogHeader.category_title,
			price_label: BaggageDialogHeader.price_label,
			perFlight: BaggageDialogHeader.perFlight
		},
		MobileBaggageSelector: {
			footer: MobileBaggageSelector.footer
		}
	},
	BaggageCard: {
		BaggageCard: {
			icon: BaggageCard.icon
		}
	},
	Baggage: {
		BaggageIcon: {
			root: BaggageIcon.root,
			carry_on: BaggageIcon.carry_on,
			small: BaggageIcon.small,
			size: BaggageIcon.size
		},
		Baggage: {
			size: Baggage.size
		}
	},
	OverweightBaggage: {
		OverweightBaggage: {
			icon: OverweightBaggage.icon
		}
	},
	SpecialEquipment: {
		SpecialEquipment: {
			card__icon: SpecialEquipment.card__icon
		}
	},
	MealService: {
		List: {
			item: MealService.list__item,
			item_selected: MealService.list__item_selected,
			item__icon: MealService.list__item_icon,
			wrapper: MealService.list_wrapper
		},
		CategoriesStyles: {
			wrapper: MealService.categories__wrapper,
			category__button: MealService.categories__button,
			mobile__title: MealService.categories_mobile__title,
			mobile__header: MealService.categories_mobile__header
		}
	},
	SlideBottom: {
		SlideBottomStyles: {
			container: MealService.slideBottom_container,
			header: SeatMap.slideBottom__header
		}
	},
	Meal: {
		Meal: {
			price: MealService.price,
			meal: MealService.meal,
			name: MealService.meal__name,
			count: MealService.count
		}
	},
	SeatMap: {
		SeatMapStyles: {
			row__serviceHeader: SeatMap.row__serviceHeader
		},
		SeatMapDisclaimerStyles: {
			disclaimer__wrp: SeatMap.disclaimer__wrp,
			disclaimer: SeatMap.disclaimer
		},
		Controls: {
			button: SeatMap.controls__button
		},
		SeatStyles: {
			seat_business: Seat.seat_business,
			seat_preferred: Seat.seat_preferred,
			seat: Seat.seat,
			number: Seat.number,
			seat_occupied: Seat.seat_occupied,
			seat_confirmed: Seat.seat_confirmed,
			seat_unavailable: Seat.seat_unavailable,
			extendedIcon: Seat.extendedIcon,
			seatPrice: Seat.seatPrice
		},
		SeatTooltipStyles: {
			popper: Seat.tooltip_popper,
			tooltip: Seat.tooltip,
			info: Seat.tooltip__info,
			tooltip_withInfo: Seat.tooltip_withInfo
		},
		SeatsInfoStyles: {
			feature: SeatsInfo.feature,
			price__wrapper: SeatsInfo.price__wrapper,
			price: SeatsInfo.price,
			image: SeatsInfo.image,
			seat: SeatsInfo.seat,
			title: SeatsInfo.title,
			freeSeat__seat: SeatsInfo.freeSeat__seat,
			seatInfo__freeSeat_container: SeatsInfo.seatInfo__freeSeat_container
		},
		ComponentStyles: {
			map: SeatMap.map,
			seatsInfo: SeatMap.seatsInfo,
			seatsInfo_content: SeatMap.seatsInfo_content
		},
		Passenger: {
			item: SeatMapPassenger.item,
			item_active: SeatMapPassenger.item_active,
			avatar: SeatMapPassenger.avatar,
			item_recommend: SeatMapPassenger.item_recommend,

			passengerName: SeatMapPassenger.passengerName,
			payload: SeatMapPassenger.payload,
			money: SeatMapPassenger.money,
			select: SeatMapPassenger.select
		},
		AirplaneStyles: {
			airplane__amenities: SeatMap.airplane__amenities,
			segment: SeatMap.airplane__segment,
			seatsDetails: SeatMap.airplane__seatsDetails
		},
		MobilePassenger: {
			container: SeatMapPassenger.mobilePassenger_container
		},
		PassengersStyles: {
			recommend__icon: SeatMap.passengers__recommend__icon,
			recommend__label: SeatMap.recommend__label
		},
		SeatsRecommendPopup: {
			main__icon: SeatMap.passengers__recommend__icon
		}
	},
	Disclaimer: {
		DisclaimerStyles: {
			disclaimer__icon: SeatMap.disclaimer__icon
		}
	},
	CheckoutAdditionalService: {
		CheckoutAdditionalService: {
			service_active: CheckoutAdditionalService.service_active,
			header: CheckoutAdditionalService.header,
			icon: CheckoutAdditionalService.icon
		},
		InsuranceUpsale: {
			content: CheckoutAdditionalService.content
		},
		LoyaltyV2: {
			loyaltyV2: CheckoutAdditionalService.loyalty
		}
	},
	PaymentForm: {
		PaymentForm: {
			gateways: PaymentForm.gateways,
			gateways_hidden: PaymentForm.gateways_hidden,
			applepay: PaymentForm.applepay,
			googlepay: PaymentForm.googlepay,
			details: PaymentForm.details,
			content: PaymentForm.content,
			timelimit: PaymentForm.timelimit,
			wrapper: PaymentForm.wrapper,
			oneMethod: PaymentForm.oneMethod
		},
		Gateway: {
			selector: PaymentForm.gateway__selector
		}
	},
	Money: {
		Money: {
			currency_after: Money.currency_after,
			currency_before: Money.currency_before
		}
	},
	Entities: {
		Fare: {
			TaxesTooltip: {
				root: DesktopFlightRoute.flightPrice__taxes
			}
		}
	}
};

export default theme;
